{"id":"LocalizedText","tags":["typography"],"prefabs":{"default":{"children":[{"component":"LocalizedText","options":"options:*"}]}}}